export default {
  shadowBlack2: '0px 0.6px 1.8px rgba(0, 0, 0, 0.11), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)',
  shadowBlack4: '0px 1.2px 3.6px rgba(0, 0, 0, 0.11), 0px 6.4px 14.4px rgba(0, 0, 0, 0.07)',
  shadowPurple: '0px 0px 2px rgba(47, 27, 154, 0.1), 0px 4px 8px rgba(42, 34, 100, 0.14)',
  shadowBrown: '0px 6.4px 14.4px 0px rgb(47 27 154 / 13%), 0px 1.2px 3.6px 0px rgba(0, 0, 0, 0.11)',
  shadowBlack8: '0px 0px 2px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.14)',
  shadowButton: '0px 1px 3px rgba(0, 0, 0, 0.1)',
  shadowPurple8: '0px 0px 2px rgba(47, 27, 154, 0.1), 0px 4px 8px rgba(42, 34, 100, 0.14)',
};
